// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__3eN7-","invalid":"styles_invalid__3kSJd","readOnly":"styles_readOnly__2wDsk","disabled":"styles_disabled__1Bwjb"};